'use client';

import {
  FieldError as HeroFieldError,
  FieldErrorProps as HeroFieldErrorProps,
} from '@heroui/react';
import { ReactNode } from 'react';

export interface FieldErrorProps extends Omit<
  HeroFieldErrorProps,
  'className' | 'style'
> {
  children: ReactNode;
}

export const FieldError = ({ children, ...props }: FieldErrorProps) => {
  return (
    <HeroFieldError
      {...props}
      className="text-xs font-medium text-danger mt-1 animate-in fade-in slide-in-from-top-1"
    >
      {children}
    </HeroFieldError>
  );
};
